import React from 'react';
import {SlGraduation} from 'react-icons/sl';
import education from '../education.svg';

const Education = () => {
  return (
    <div className=' bg-[#142d4c] h-[100vh] pt-10'>
        <h1 className=' text-3xl font-extrabold flex justify-center text-white mb-5'>EDUCATION</h1>
        <div className=' flex justify-center items-center'>
            <div>
                <img src={education} alt="edu" className=' w-[470px] h-auto' />
            </div>

            <div className='studies flex flex-col gap-5'>

                <div className=' bg-blue-950  w-auto h-36 ml-9 mr-9 rounded-2xl flex items-center p-9 pr-16 hover:scale-105 duration-150'>
                    <SlGraduation className=' w-16 h-16 flex text-white bg-blue-400 p-2 rounded-full' />
                    <div className=' flex flex-col text-white font-bold text-md ml-3'>
                        <p>2021 - 2024</p>
                        <p className=' w-auto'>Bachelors of Technology</p>
                        <p className=' w-max'>Vishnu Institute of Technology (A)</p>
                        <p>Bhimavaram</p>
                    </div>
                </div>
                <div className=' bg-blue-950  w-auto h-36 ml-9 mr-9 rounded-2xl flex items-center p-9 pr-16 hover:scale-105 duration-150'>
                    <SlGraduation className=' w-16 h-16 flex text-white bg-blue-400 p-2 rounded-full' />
                    <div className=' flex flex-col text-white ml-4 font-bold text-md '>
                        <p>2018 - 2021</p>
                        <p className=' w-auto'>Diploma</p>
                        <p className=' w-max'>GOVT Polytechnic</p>
                        <p>Tadepalligudem</p>
                    </div>
                </div>
                <div className=' bg-blue-950  w-auto h-36 ml-9 mr-9 rounded-2xl flex items-center p-9 pr-16 hover:scale-105 duration-150'>
                    <SlGraduation className=' w-16 h-16 flex text-white bg-blue-400 p-2 rounded-full' />
                    <div className=' flex flex-col text-white ml-4 font-bold text-md'>
                        <p>2017 - 2018</p>
                        <p className=' w-auto'>SSC</p>
                        <p className=' w-max'>St. Marys's School</p>
                        <p>Palacole</p>
                    </div>
                </div>

            </div>
            
        </div>
    </div>
  )
}

export default Education